/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import PlatformMigration from '../platform-migration'
import Signup from '../signup'
import TermsOfService from '../terms-of-service';
import BasicInfo from '../basic-info';
import BasicInfoCompany from '../basic-info-company';
import AccountInfo1 from '../account-info-1';
import AccountInfo2 from '../account-info-2';
import AccountInfo3 from '../account-info-3';
import AccountInfo4 from '../account-info-4';
import PowerOfAttorney from '../power-of-attorney';
import Payment from '../payment';
import AddTeam from '../add-team';
import Thanks from '../thanks';
import Finish from '../finish'
import ForgotPassword from '../forgot-pw'
import ResetPassword from '../reset-pw'
import ViewTerms from '../view-terms'
import ViewPrivacy from '../view-privacy'
import Maintenance from '../maintenance'
import Verification from '../resendVerification';

export const leftRoutes = [{
  path: '/',
  component: PlatformMigration,
}, 

{
  path: '/basicinfo',
  component: BasicInfo,
}, {
  path: '/basicinfo-company',
  component: BasicInfoCompany,
}, {
  path: '/accountInfo1',
  component: AccountInfo1,
}, {
  path: '/accountInfo2',
  component: AccountInfo2,
}, {
  path: '/accountInfo3',
  component: AccountInfo3,
}, {
  path: '/accountInfo4',
  component: AccountInfo4,
}, {
  path: '/powerOfAttorney',
  component: PowerOfAttorney,
}, {
  path: '/payment',
  component: Payment,
}, {
  path: '/addTeam',
  component: AddTeam,
}, {
  path: '/finish',
  component: Finish,
},  {
  path: '/forgot-password',
  component: ForgotPassword,
},  {
  path: '/reset-password/:tmp',
  component: ResetPassword,
},  {
  path: '/view-terms',
  component: ViewTerms,
},  {
  path: '/privacy',
  component: ViewPrivacy,
},  {
  path: '/maintenance',
  component: Maintenance,
},  {
  path: '/email-verification',
  component: Verification,
}]

export default leftRoutes;